// extracted by mini-css-extract-plugin
export default {"boxError":"styles_boxError__sGfdv","iconError":"styles_iconError__j7pF1"};